import { createRootRouteWithContext, Outlet, useLocation } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/router-devtools"
import I18nProvider from "@/providers/I18nProvider"
import Container from "@/app/Container"
import AirTable from "@/app/AirTable"

import "simplebar-react/dist/simplebar.min.css"
import "@/app/styles/muiOverwrite.scss"
import "@/app/global.scss"
import { AuthContextProps } from "@/providers/types.ts"

export const Route = createRootRouteWithContext<AuthContextProps>()({
  component: RootComponent,
})

function RootComponent() {
  const { authenticated, login } = Route.useRouteContext()
  const location = useLocation()

  // 공개 라우트 체크
  const publicPaths = ["/signup"]
  const isPublicRoute = publicPaths.some((path) => location.pathname.startsWith(path))

  // 인증이 필요한데 인증되지 않은 경우 로그인 페이지로
  if (!authenticated && !isPublicRoute) {
    login?.()

    return null
  }

  return (
    <div>
      <I18nProvider>
        <Container>
          <Outlet />
        </Container>
        <AirTable />
      </I18nProvider>
      {["local", "dev"].includes(import.meta.env.VITE_MODE) && <TanStackRouterDevtools />}
    </div>
  )
}
